/**
 * Розбір JWT доступу без зовнішніх бібліотек.
 *
 * Використовуємо тільки для того, щоб показати касиру, під ким він
 * працює. Жодних рішень щодо доступу на основі цих даних не приймаємо —
 * права перевіряє бекенд.
 */
export const decodeToken = (token) => {
    if (!token || typeof token !== 'string') {
        return null;
    }

    const payload = token.split('.')[1];

    if (!payload) {
        return null;
    }

    try {
        const normalized = payload.replace(/-/g, '+').replace(/_/g, '/');
        const json = decodeURIComponent(
            atob(normalized)
                .split('')
                .map((char) => `%${`00${char.charCodeAt(0).toString(16)}`.slice(-2)}`)
                .join('')
        );

        return JSON.parse(json);
    } catch (error) {
        console.warn('Не вдалося розібрати токен доступу', error);
        return null;
    }
};

/**
 * Ім'я користувача для показу в інтерфейсі.
 *
 * Бекенд наразі кладе в токен лише `user_id`, тому claim-и підбираємо
 * «як пощастить». Якщо в токен додадуть `username` або `full_name`,
 * інтерфейс підхопить це без змін коду (див. документ backend-changes.md).
 */
export const getUserDisplayName = (token) => {
    const payload = decodeToken(token);

    if (!payload) {
        return null;
    }

    return (
        payload.full_name ||
        payload.name ||
        payload.username ||
        payload.user_name ||
        payload.email ||
        null
    );
};
